import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TypeOverrideService {

  constructor(private http: HttpClient) { }

  getTraining(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/typeoverride/training`
      );
  }

  newTraining(type: string, value: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/typeoverride/training`,
        JSON.stringify({ type: type, value: value })
      );
  }

  deleteTraining(id: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/typeoverride/training/${id}`
      );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/type-override.service.ts